const breakBefore = {
    name: "break-before",
    path: "/break-before",
    title: "break-before",
    description: "Utilities for controlling how a column or page should break before an element.",
    value: {
        "break-before": {
            "break-before-auto": "auto",
        "break-before-avoid": "avoid",
        "break-before-all": "all",
        "break-before-avoid-page": "avoid-page",
        "break-before-page": "page",
        "break-before-column": "column",
        }
    },
    exampleData: [
        {
            "title": "break-before-column, break-before-page",
            "description": "utilities like to to control how a column or page break should behave before an element:",
            "moreDescription": "",
            "parentClass": "",
            "example": {
                "element": "",
                "src": [],
                "className": "",
                "code": `<div class="columns-2">
    <p>Well, let me tell you something, ...</p>
    <p class="break-before-column">Sure, go ahead, laugh...</p>
    <p>Maybe we can live without...</p>
    <p>Look. If you think this is...</p>
</div>`
            }
        },
        {
            "title": "break-before ",
            "description": "utility with a breakpoint variant like md: to only apply the utility at medium screen sizes and above:",
            "moreDescription": "",
            "parentClass": "",
            "example": {
                "element": "",
                "src": "",
                "className": "",
                "code": `<div class="break-before-column md:break-before-auto ...">
  <!-- ... -->
</div>`
            }
        }
    ]
}
export default breakBefore;